import { render, staticRenderFns } from "./BasketItems.vue?vue&type=template&id=05bf68bd&"
import script from "./BasketItems.vue?vue&type=script&lang=js&"
export * from "./BasketItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports